import React, { useState } from "react";
import { P_Props } from "./ResetPassword.type";
import { Form, Field } from "react-final-form";
import { FormUtil, loadCallback } from "../../../utils";
import { InputAdornment, IconButton, TextField } from "@material-ui/core";
import { Visibility as VisibilityIcon, VisibilityOff as VisibilityOffIcon } from "@material-ui/icons";

const ResetPasswordPresenter: React.FC<P_Props> = (props) => {
  const [visiblePassword, setVisiblePassword] = useState<boolean>(false);

  let submit: any;

  const toggleVisiblePassword = () => {
    setVisiblePassword(!visiblePassword);
  };

  return (
    <>
      <div className="reset-password-form">
        <div className="login-form__title">Reset your password</div>
        <div className="password-form__note">
          Enter your registered email address and we will send you a link to reset your password
        </div>
        <Form
          // initialValues={
          //   props.initData
          //     ? bindingLoginToForm(props.initData)
          //     : {
          //         name: "",
          //         password: "",
          //       }
          // }
          initialValuesEqual={() => true}
          onSubmit={async (values, form) => {
            // props.onSubmit(values);
          }}
          render={({ handleSubmit, form, pristine }) => {
            submit = handleSubmit;
            return (
              <form onSubmit={handleSubmit} className="login-form-input">
                <Field name="password" validate={FormUtil.Rule.required("Please input password")}>
                  {({ input, meta, ...rest }) => {
                    return (
                      <TextField
                        {...input}
                        {...rest}
                        fullWidth
                        placeholder="Password"
                        variant="outlined"
                        className="form-text-field"
                        inputProps={{ className: "input" }}
                        onChange={(e) => input.onChange(e.target.value)}
                        helperText={meta.touched ? meta.error : ""}
                        error={meta.error && meta.touched}
                        InputProps={{
                          type: visiblePassword ? "text" : "password",
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={toggleVisiblePassword}>
                                {visiblePassword ? (
                                  <VisibilityIcon style={{ fontSize: "2rem" }} />
                                ) : (
                                  <VisibilityOffIcon style={{ fontSize: "2rem" }} />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    );
                  }}
                </Field>
                <Field name="passwordConfirm" validate={FormUtil.Rule.required("Please input password")}>
                  {({ input, meta, ...rest }) => {
                    return (
                      <TextField
                        {...input}
                        {...rest}
                        fullWidth
                        placeholder="Password"
                        variant="outlined"
                        className="form-text-field"
                        inputProps={{ className: "input" }}
                        onChange={(e) => input.onChange(e.target.value)}
                        helperText={meta.touched ? meta.error : ""}
                        error={meta.error && meta.touched}
                        InputProps={{
                          type: visiblePassword ? "text" : "password",
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={toggleVisiblePassword}>
                                {visiblePassword ? (
                                  <VisibilityIcon style={{ fontSize: "2rem" }} />
                                ) : (
                                  <VisibilityOffIcon style={{ fontSize: "2rem" }} />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    );
                  }}
                </Field>
                <button
                  className="login-form__btn-login"
                  onClick={(e) => {
                    e.preventDefault();
                    loadCallback(submit, e);
                  }}
                >
                  Submit
                </button>
              </form>
            );
          }}
        />
      </div>
    </>
  );
};

export default ResetPasswordPresenter;
